@if (vm$ | async; as vm) {
  <app-agenda title="Cumpleaños" [months]="vm.months" [itemTemplate]="birthdayItem"
    upcomingEmptyMessage="No hay próximos cumpleaños en este período."
    [loading]="vm.loading" [error]="vm.error" [canView]="vm.canView"
    emptyMessage="Sin cumpleaños registrados este mes." (retry)="retry()"></app-agenda>
  <ng-template #birthdayItem let-member let-isPast="isPast">
    <div class="birthday-member" [class.is-past]="isPast">
      <a class="member-info" [routerLink]="['/units', vm.unitId, 'members', member.id]">
        <span class="member-name">{{ member.firstName }} {{ member.lastName }}</span>
        <span class="birthday-age">{{ isPast ? 'Cumplió' : 'Cumple' }} {{ member.birthdayAge }} {{ member.birthdayAge === 1 ? 'año' : 'años' }}</span>
        @if (vm.showCommunity && member.communityName) { <small>{{ member.communityName }}</small> }
      </a>
      @if (phoneLink(member.phone); as phone) {
        <a class="call-button" [href]="phone" [attr.aria-label]="'Llamar a ' + member.firstName + ' ' + member.lastName" [title]="member.phone"><mat-icon>call</mat-icon></a>
      } @else {
        <button class="call-button" disabled [attr.aria-label]="member.firstName + ' ' + member.lastName + ': sin teléfono'" title="Sin teléfono registrado"><mat-icon>call</mat-icon></button>
      }
    </div>
  </ng-template>
} @else {
  <p role="status">Cargando cumpleaños…</p>
}
